import { http } from '@/store/api/http-common';

const saveTicket = async (params) => {
	try {
		const { data } = await http.post('tickets', params);
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const exportTicketsReport = async (params = {}) => {
	try {
		const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

		const response = await http.get('tickets/export', {
			params: { ...params, timezone },
			responseType: 'blob',
		});

		const url = window.URL.createObjectURL(new Blob([response.data]));
		const link = document.createElement('a');
		link.href = url;

		const timestamp = new Date().toISOString().slice(0, 16).replace('T', '_').replace(':', '-');
		link.setAttribute('download', `TicketsExport_${timestamp}.xlsx`);
		document.body.appendChild(link);
		link.click();
		link.remove();

		return true;
	} catch (error) {
		return Promise.reject(error);
	}
};

const exportSummaryTicketsReport = async () => {
	try {
		const response = await http.get('tickets/export-summary', {
			responseType: 'blob',
		});

		const url = window.URL.createObjectURL(new Blob([response.data]));
		const link = document.createElement('a');
		link.href = url;

		const timestamp = new Date().toISOString().slice(0, 16).replace('T', '_').replace(':', '-');
		link.setAttribute('download', `ExportSummaryUserReport${timestamp}.xlsx`);
		document.body.appendChild(link);
		link.click();
		link.remove();

		return true;
	} catch (error) {
		return Promise.reject(error);
	}
};

const addUserConfirm = async (params) => {
	try {
		const { data } = await http.post('tickets/add-user-confirm', params);
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const addUserTicket = async (params) => {
	try {
		const { data } = await http.post('tickets/add-additional-user', params);
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const reassignResponsible = async (id, params) => {
	try {
		const { data } = await http.put(`tickets/reassign-responsible/${id}`, params);
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
}

const getTicketById = async (id) => {
	try {
		const { data } = await http.get(`tickets/${id}`);
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const sendTicketCloseNotification = async (id) => {
	try {
		const { data } = await http.post(`tickets/ticket-notification/${id}`);
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const getTicket = async (params) => {
	try {
		const { data } = await http.get('tickets', { params });
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const getTicketsForUsers = async (params) => {
	try {
		const { data } = await http.get('tickets/get-my-tickets', { params });
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const getTicketsForResponsibles = async (params) => {
	try {
		const { data } = await http.get('tickets/get-subtype-tickets', { params });
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const getDeletedTicketsForResponsibles = async (params) => {
	try {
		const { data } = await http.get('tickets/get-subtype-tickets', { params: { ...params, deleted: true } });
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const closeTicket = async (id) => {
	try {
		const { data } = await http.put(`tickets/close-ticket/${id}`);
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const confirmTicket = async (id) => {
	try {
		const { data } = await http.put(`tickets/confirm-ticket/${id}`);
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const declineTicket = async (id, params) => {
	try {
		const { data } = await http.put(`tickets/decline-ticket/${id}`, params);
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const deleteTicket = async (id, params) => {
	try {
		const { data } = await http.delete(`tickets/${id}`, { params });
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const reclassifyTicket = async (ticketId, params) => {
	try {
		const { data } = await http.patch(`tickets/reclassify-ticket/${ticketId}`, params);
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const changeCompany = async (ticketId, params) => {
	try {
		const { data } = await http.patch(`tickets/change-company/${ticketId}`, params);
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};


export {
	saveTicket,
	getTicket,
	getTicketById,
	closeTicket,
	getTicketsForUsers,
	getTicketsForResponsibles,
	getDeletedTicketsForResponsibles,
	reassignResponsible,
	confirmTicket,
	addUserConfirm,
	addUserTicket,
	sendTicketCloseNotification,
	exportTicketsReport,
	exportSummaryTicketsReport,
	declineTicket,
	reclassifyTicket,
	changeCompany,
	deleteTicket,
};
